<fieldset class="container" [class.ponctuel]="rsp.typeRetour === '03'">
  <!-- RSP entries -->

  @if (rsp.numFacture; as val) {
    <div class="flexrow">
      <span class="title">N° Facture</span>
      <span class="value">{{ val }}</span>
    </div>
  }

  @if (rsp.data.dateFacture | dateShortFr; as val) {
    <div class="flexrow">
      <span class="title">Date Facture</span>
      <span class="value">{{ val }}</span>
    </div>
  }

  @if (rsp.numSecu; as val) {
    <div class="flexrow">
      <span class="title">NIR</span>
      <span class="value">{{ val }}</span>
    </div>
  }

  @if (rsp.data.dateNaissBenef; as val) {
    <div class="flexrow">
      <span class="title">Date - Rang Naissance</span>
      <span class="value">{{ val | dateShortFr }}@if (rsp.data.rangNaiss; as val) {
        <span>&nbsp;-&nbsp;{{ val }}</span>
      } </span>
    </div>
  }

  @if (rsp.data.nomBenef; as val) {
    <div class="flexrow">
      <span class="title">Nom</span>
      <span class="value">{{ val }}</span>
    </div>
  }

  @if (rsp.data.prenomBenef; as val) {
    <div class="flexrow">
      <span class="title">Prénom</span>
      <span class="value">{{ val }}</span>
    </div>
  }

  <div class="flexrow">
    <span class="title">Type Retour</span>
    <span class="value">{{ stateHelper.typeRetourLabels[rsp.data.typeRetour] }}</span>
  </div>

  <div class="flexrow">
    <span class="title">Risque</span>
    <span class="value">{{ stateHelper.risque[rsp.data.risque] || rsp.data.risque }}</span>
  </div>

  @if (rsp.data.traitementPartAMC; as val) {
    <div class="flexrow">
      <span class="title">Trait. Part AMC</span>
      <span class="value">{{ stateHelper.traitementPartAMC[val] || val }}</span>
    </div>
  }

  <div class="flexrow">
    <span class="title">Total Paiement</span>
    <span class="value">{{ +(rsp.data.totalPaiement) / 100 }} €</span>
  </div>

  <div class="flexrow">
    <span class="title">Total AMO</span>
    <span class="value">{{ +(rsp.data.totalAMO??0) / 100 }} €</span>
  </div>

  <div class="flexrow">
    <span class="title">Total AMC</span>
    <span class="value">{{ +(rsp.data.totalAMC??0) / 100 }} €</span>
  </div>

  @if (rsp.data.premierRejet) {
    <div class="flexrow">
      <span class="title">Premier Rejet</span>
      <span class="value">{{ rsp.data.premierRejet }}</span>
    </div>
  }

  <div class="flexrow">
    <span class="title">Lib. Virement</span>
    <div>
      <div class="value">{{ rsp.data.libVirement1 }}</div>
      <div class="value" style="font-size: 0.8rem; color: #64748b;">{{ rsp.data.libVirement2 }}</div>
    </div>
  </div>

  @if (false) {
    <div class="flexrow">
      <span class="title">Top Paiement</span>
      <span class="value">{{ rsp.data.topPaiement }}</span>
    </div>
  }

  @if (false) {
    <div class="flexrow">
      <span class="title">Top Rejet</span>
      <span class="value">{{ rsp.data.topRejet }}</span>
    </div>
  }

  @if (false) {
    <div class="flexrow">
      <span class="title">Top Différé</span>
      <span class="value">{{ rsp.data.topDiffere }}</span>
    </div>
  }

  @if (rsp.data.partAMO?.traitement) {
    <fieldset>
      <legend>Part AMO</legend>
      @if (stateHelper.getEtatRsp(rsp.data, true); as etatAmo) {
        <div class="flexrow">
          <span class="title">Traitement</span>
          <span class="value" [ngClass]="etatAmo.class">{{ etatAmo.label }}</span>
        </div>
      }
      <div class="flexrow">
        <span class="title">Montant demandé</span>
        <span class="value">&nbsp;&nbsp;{{ +(rsp.data.partAMO?.montantDemande??0) / 100 }} €</span>
      </div>
      <div class="flexrow">
        <span class="title">Montant Paiement</span>
        <span class="value">&nbsp;&nbsp;{{ +(rsp.data.partAMO?.montantPaiement??0) / 100 }} €</span>
      </div>
    </fieldset>
  }

  @if (rsp.data.partAMC?.traitement) {
    <fieldset>
      <legend>Part AMC</legend>
      @if (stateHelper.getEtatRsp(rsp.data, false); as etatAmc) {
        <div class="flexrow">
          <span class="title">Traitement</span>
          <span class="value" [ngClass]="etatAmc.class">{{ etatAmc.label }}</span>
        </div>
      }
      <div class="flexrow">
        <span class="title">Montant demandé</span>
        <span class="value">&nbsp;&nbsp;{{ +(rsp.data.partAMC?.montantDemande??0) / 100 }} €</span>
      </div>
      <div class="flexrow">
        <span class="title">Montant Paiement</span>
        <span class="value">&nbsp;&nbsp;{{ +(rsp.data.partAMC?.montantPaiement??0) / 100 }} €</span>
      </div>
      <div class="flexrow">
        <span class="title">Id Adherent</span>
        <span class="value">&nbsp;&nbsp;{{ rsp.data.partAMC?.idAdherent }}</span>
      </div>
      <div class="flexrow">
        <span class="title">Num Dest AMC</span>
        <span class="value">&nbsp;&nbsp;{{ rsp.data.partAMC?.numDestAMC }}</span>
      </div>
    </fieldset>
  }

  @if (rsp.data.rejet?.length) {
    <div class="rejets-block">
      <div class="title">Rejets</div>
      <ul>
        @for (rej of rsp.data.rejet; track rej) {
          <li>
            <strong>{{ rej.code }}</strong> — {{ rej.libelle }}
          </li>
        }
      </ul>
    </div>
  }

  @if (rsp.data.MFI;) {
    <fieldset>
      <legend>Mvt. Financier</legend>
      <div class="flexrow">
        <span class="title">Réf. Dette</span>
        <span class="value">&nbsp;&nbsp;{{ rsp.data.MFI.refDette }}</span>
      </div>
      <div class="flexrow">
        <span class="title">Date Dette</span>
        <span class="value">&nbsp;&nbsp;{{ rsp.data.MFI.dateDette | dateShortFr }}</span>
      </div>
      <div class="flexrow">
        <span class="title">Nat. Dette</span>
        <span class="value">&nbsp;&nbsp;{{ stateHelper.natureDetteLabels[rsp.data.MFI.natureDette] }}</span>
      </div>
      <div class="flexrow">
        <span class="title">Nat. Opé.</span>
        <span class="value">&nbsp;&nbsp;{{ stateHelper.natureOperationLabels[rsp.data.MFI.natureOperation] }}</span>
      </div>
      <div class="flexrow">
        <span class="title">Montant</span>
        <span class="value">&nbsp;&nbsp;{{ +(rsp.data.MFI.montantMFI)/100 }} €</span>
      </div>
      <div class="flexrow">
        <span class="title">Solde</span>
        <span class="value">&nbsp;&nbsp;{{ +(rsp.data.MFI.montantSolde??0)/100 }} €</span>
      </div>
    </fieldset>
  }
</fieldset>

@if (isRecon) { <!-- Reconciliation mode. Show num_facture input field -->
  <div>
    <br/>
    <div class="info-zone">
      <span class="info-icon">&#9432;</span>
      <span>Ce RSP n'est pas rapproché</span>
      <button mat-flat-button color="primary" (click)="reconcile()" style="margin-left: auto;">Rapprocher</button>
    </div>
    Facture de rattachement :
    <mat-form-field appearance="outline">
      <mat-label>Numéro de facture</mat-label>
      <input matInput placeholder="Numéro de facture" [(ngModel)]="numFacture">
    </mat-form-field>
  </div>
}